import React from "react";

export default function Brush() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1613_3470)">
        <path
          d="M14.5692 27.6729C17.3832 25.9809 21.2042 23.8659 24.4682 20.6019C31.4982 13.5729 37.1972 3.63187 35.7822 2.21687C34.3682 0.802871 24.4272 6.50187 17.3972 13.5309C14.1322 16.7959 12.0182 20.6159 10.3262 23.4299L14.5692 27.6729Z"
          fill="#3B88C3"
        />
        <path
          d="M0.427734 34.7437C0.427734 34.7437 7.49873 36.1577 12.4487 31.2077C14.5697 29.0867 14.5697 26.2587 14.5697 26.2587L11.7407 23.4297C11.7407 23.4297 8.20573 24.1377 6.79073 25.5517C5.37673 26.9657 4.27273 29.7837 3.90273 31.1497C3.22673 33.6517 0.427734 34.7437 0.427734 34.7437Z"
          fill="#C1694F"
        />
        <path
          d="M17.882 25.3278L12.714 20.1598C12.323 19.7688 11.756 19.8338 11.444 20.3048L10.321 22.0098C10.01 22.4808 10.05 23.1518 10.408 23.5108L14.53 27.6338C14.888 27.9918 15.56 28.0308 16.031 27.7208L17.736 26.5968C18.208 26.2858 18.272 25.7188 17.882 25.3278Z"
          fill="#CCD6DD"
        />
        <path
          d="M11.2287 32.2601C10.0377 33.0291 9.40273 32.3881 9.61973 31.6511C9.84073 30.9001 9.49973 30.0031 8.38273 30.2371C7.26573 30.4701 6.52673 29.8831 6.87973 28.4701C7.22773 27.0771 5.79473 26.6071 5.12573 28.0351C4.54373 29.1951 4.10873 30.3941 3.90373 31.1501C3.22673 33.6531 0.427734 34.7451 0.427734 34.7451C0.427734 34.7451 6.41573 35.9291 11.2287 32.2601Z"
          fill="#A0041E"
        />
      </g>
      <defs>
        <clipPath id="clip0_1613_3470">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
